<p class="block_title">Настройки пароля</p>
<hr>
<div class="settings__user_password">
  <form class="settings__user_password__form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field hintLabel="Max 30 символов" appearance="outline">
      <mat-label><mat-icon>security</mat-icon>Старый пароль</mat-label>
      <input matInput #password placeholder="Ваш пароль" [type]="hidePassword ? 'password' : 'text'" formControlName="password">
      <button class="icon-button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Скрыть пароль'"
        [attr.aria-pressed]="hidePassword">
        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-hint align="end">{{ password.value?.length || 0 }}/30</mat-hint>
    </mat-form-field>

    <mat-form-field hintLabel="Max 30 символов" appearance="outline">
      <mat-label><mat-icon>security</mat-icon>Новый пароль</mat-label>
      <input matInput #newPassword placeholder="Новый пароль" [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword">
      <button class="icon-button" mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword" [attr.aria-label]="'Скрыть пароль'"
        [attr.aria-pressed]="hideNewPassword">
        <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-hint align="end">{{ newPassword.value?.length || 0 }}/30</mat-hint>
    </mat-form-field>

    <mat-form-field hintLabel="Max 30 символов" appearance="outline">
      <mat-label><mat-icon>security</mat-icon>Повторите новый пароль</mat-label>
      <input matInput #newPasswordCheck placeholder="Повторите новый пароль" [type]="hideNewPasswordCheck ? 'password' : 'text'" formControlName="newPasswordCheck">
      <button class="icon-button" mat-icon-button matSuffix (click)="hideNewPasswordCheck = !hideNewPasswordCheck" [attr.aria-label]="'Скрыть пароль'"
        [attr.aria-pressed]="hideNewPasswordCheck">
        <mat-icon>{{ hideNewPasswordCheck ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-hint align="end">{{ newPasswordCheck.value?.length || 0 }}/30</mat-hint>
    </mat-form-field>
    <hr>
    <button
      class="form__button"
      [class.active]="form.valid"
      mat-raised-button
      color="primary"
      [disabled]="!form.valid">Сменить пароль</button>
  </form>
</div>
